module.exports = __webpack_public_path__ + "img/american express.b3abb55d.png";